<template>
  <div class="compensation_sheet">
    <div class="compensation_head">
      <div class="head_left">
        <div class="left_title">{{ $t('申请包赔') }}</div>
        <p>{{ $t('申请包赔desc', { _: levelItem.min_recharge || '42000' }) }}</p>
      </div>
      <div class="head_right" @click="close">
        <van-icon name="cross" color="#31e2a5" size="16" />
      </div>
    </div>
    <div class="compensation_status" v-if="levelItem.valid_count >= levelItem.invite_count">
      <p>{{ $t('已达到申请条件') }}</p>
      <span>{{ $t('新充值有效人数达到要求') }}</span>
    </div>
    <div class="compensation_status" v-else>
      <p>{{ $t('暂未达到申请条件') }}</p>
      <span>{{ $t('新充值有效人数未达到要求') }}</span>
    </div>
    <div class="compensation_progress">
      <div class="progress_left">{{ $t('邀请注册') }}</div>
      <div class="progress_right">{{ invite_count }}/{{ levelItem.invite_count || 0 }}</div>
    </div>
    <div class="compensation_progress">
      <div class="progress_left">{{ $t('有效充值') }}</div>
      <div class="progress_right red">{{ levelItem.valid_count || 0 }}/{{ levelItem.invite_count || 0 }} · {{
        $money(levelItem.min_recharge || '42000') }}</div>
    </div>
    <div class="compensation_progress">
      <div class="progress_left">{{ $t('账户余额') }}</div>
      <div class="progress_right">
        {{ $money(userInfo.money_plus || '0.00') }} / {{ $money(levelItem.min_recharge
          || '42000') }}
      </div>
    </div>
    <div class="compensation_btn" @click="submit" :style="status ? {} : { opacity: .5 }">
      {{ levelItem.status == 0 ? $t('待确认') : $t('提交包赔申请') }}
    </div>
    <div class="compensation_list">
      <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
        :loading-text="$t('Hint.loading')" immediate-check>
        <template v-if="list.length">
          <div class="compensation_list_title">{{ $t('申请记录') }}</div>
          <div v-for="(item, index) in list" :key="`item_${index}`" class="item_wrap app_card">
            <div class="item_wrap_head">
              <div class="head_left">
                <span>{{ $t('申请金额') }}</span>
                <p>{{ $money(item.money) }}</p>
              </div>
              <div class="status">{{ getStatus(item.status) }}</div>
            </div>
            <p v-if="item.status == 2 && item?.item?.review?.remark">
              {{ item?.item?.review?.remark }}
            </p>
            <div class="time">{{ $format(item.indate) }}</div>
          </div>
        </template>
      </List>
    </div>
  </div>
</template>
<script>
import { Icon, Toast, List } from "vant";
import { post } from "@/utils/newRequest";
import { mapGetters } from "vuex";
import { MARKETING_GIFT } from "@/api"
export default {
  components: {
    [Icon.name]: Icon,
    Toast,
    List
  },
  props: {
    keyNum: Number
  },
  data() {
    return {
      invite_count: 0,
      levelItem: {},
      status: false,
      list: [],
      page: 0,
      loading: false,
      hasMore: true,
      loadingRequest: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    getStatus(_str) {
      switch (_str) {
        case 0:
          return this.$t('待确认');
          break;
        case 1:
          return this.$t('完成');
          break;
        case 2:
          return this.$t('拒绝');
          break;
        default:
          break;
      }
    },
    async submit() {
      if (!this.status) return;
      Toast.loading();
      try {
        const res = await MARKETING_GIFT({
          act: 'apply',
          invite_count: this.levelItem.invite_count
        })
        Toast.clear();
        Toast(res.msg)
        setTimeout(() => {
          this.$emit('close')
        }, 500)
      } catch (error) {
        Toast.clear();
        error.msg && Toast(error.msg)
      }
    },
    close() {
      this.$emit('close')
    },
    async getConfig() {
      Toast.loading();
      try {
        const { data } = await MARKETING_GIFT({
          act: 'progress'
        })
        Toast.clear();
        this.invite_count = data.invite_count || 0;
        this.levelItem = data.levels.find(item => item.status == -1 || item.status == 0) || data.levels[data.levels.length - 1];
        if (this.levelItem.completed == 1) {
          if (this.levelItem.can_apply == 1) {
            this.status = true;
          } else {
            this.status = false
          }
        } else {
          this.status = false;
        }
        console.log(this.levelItem)
      } catch (error) { Toast.clear(); }
    },
    async getList(lower = false) {
      if (this.loadingRequest) return;
      this.loadingRequest = true;
      if (!lower) {
        this.page++;
      }
      this.loading = true;
      try {
        const { lists, hasMorePages, total: _total } = await post("/marketing/gift", {
          type: 'invite_rebate',
          act: 'list',
          pagesize: 20,
          page: this.page,
        });
        const realList = lists;
        this.hasMore = hasMorePages;
        if (lower) {
          this.list = [...realList]
        } else {
          this.list = [...this.list, ...realList];
        }
        this.loading = false;
        this.loadingRequest = false;
      } catch (error) {
        if (!lower) this.page--;
        this.loading = false;
        this.loadingRequest = false;
      }
    },
  }

}
</script>
<style lang="less" scoped>
.compensation_sheet {
  padding: 18px 16px 30px;
  background: #f7f9fc;
  max-height: calc(90vh - 48px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar {
    display: none;
  }

  .compensation_head {
    display: grid;
    grid-template-columns: 1fr 36px;
    gap: 12px;

    .head_left {
      .left_title {
        color: #111827;
        font-size: 20px;
        font-weight: 900;
      }

      p {
        margin: 6px 0 0;
        color: #697386;
        font-size: 13px;
        line-height: 1.5;
      }
    }

    .head_right {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 8px 16px #0f172a0f;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .compensation_status {
    padding: 12px;
    border-radius: 14px;
    background: #fff6f6;
    border: 1px solid rgba(255, 86, 100, .14);

    p {
      color: #111827;
      font-size: 15px;
      font-weight: 600;
    }

    span {
      margin-top: 4px;
      color: #6b7280;
      font-size: 12px;
      line-height: 1.45;
    }
  }

  .compensation_progress {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 40px;
    padding: 0 12px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid rgba(15, 23, 42, .06);

    .progress_left {
      color: #6b7280;
      font-size: 13px;
      font-weight: 600;
    }

    .progress_right {
      color: #31e2a5;
      font-size: 13px;
      font-weight: 600;
      text-align: right;
    }

    .red {
      color: #e84f62;
    }
  }

  .compensation_btn {
    font-size: 14px;
    color: #0f172a;
    font-weight: 600;
    box-shadow: 0 9px 20px #31e2a547;
    background: linear-gradient(90deg, #8ff5d1, #31e2a5); // #a6b5af;
    height: 42px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .compensation_list {
    margin-top: 10px;

    :deep(.van-list) {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .compensation_list_title {
      color: #111827;
      font-size: 18px;
      font-weight: 600;
    }

    .item_wrap {
      padding: 14px;

      .item_wrap_head {
        display: flex;
        justify-content: space-between;
        gap: 12px;

        .head_left {
          font-weight: 600;

          span {
            color: #7a8597;
            font-size: 12px;
          }

          p {
            color: #111827;
            font-size: 14px;
            margin-top: 4px;
          }
        }

        .status {
          box-shadow: 0 9px 20px #31e2a547;
          background: linear-gradient(90deg, #8ff5d1, #31e2a5);
          border-radius: 100px;
          font-size: 14px;
          padding: 4px 12px;
          color: #0f172a;
          font-weight: 600;
          height: fit-content;
        }
      }

      >p {
        margin: 9px 0 0;
        padding: 8px 10px;
        border-radius: 12px;
        background: #ffb24d1f;
        color: #9a5d00;
        font-size: 12px;
        font-weight: 800;
      }

      .time {
        color: #7a8597;
        font-size: 12px;
        margin-top: 4px;
      }
    }
  }
}
</style>